/**
 * Primer paso común de los JSON que llegan por IPC desde otro proceso (kero vía el main) para el
 * broadcast LOCAL: el status (`localBroadcastStatus`) y las stats (`localBroadcastStats`) lo
 * comparten. Acepta el string crudo o el objeto ya parseado; cualquier otra cosa (JSON inválido,
 * escalares, arrays) se ignora con null para no romper el broadcast por un mensaje raro.
 */
export function parseLocalBroadcastPayload(
  payload: unknown,
): Record<string, unknown> | null {
  let value: unknown = payload;

  if (typeof value === "string") {
    try {
      value = JSON.parse(value);
    } catch {
      return null;
    }
  }

  if (value === null || typeof value !== "object" || Array.isArray(value)) {
    return null;
  }

  return value as Record<string, unknown>;
}

/** Contador acumulado: entero finito >= 0. Cualquier otra cosa cuenta como 0. */
export function readCount(value: unknown): number {
  if (typeof value !== "number" || !Number.isFinite(value) || value <= 0) {
    return 0;
  }

  return Math.floor(value);
}

/** String no vacío, o el fallback si el otro proceso no lo mandó (o mandó otra cosa). */
export function readLabel(value: unknown, fallback: string): string {
  return typeof value === "string" && value.length > 0 ? value : fallback;
}
